var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_34505)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.02656 10.749C3.05781 10.749 3.08906 10.7459 3.12031 10.7412L5.74844 10.2803C5.77969 10.274 5.80938 10.26 5.83125 10.2365L12.4547 3.61309C12.4692 3.59863 12.4807 3.58146 12.4885 3.56256C12.4963 3.54366 12.5004 3.52339 12.5004 3.50293C12.5004 3.48247 12.4963 3.4622 12.4885 3.4433C12.4807 3.4244 12.4692 3.40723 12.4547 3.39277L9.85781 0.794336C9.82812 0.764648 9.78906 0.749023 9.74687 0.749023C9.70469 0.749023 9.66563 0.764648 9.63594 0.794336L3.0125 7.41777C2.98906 7.44121 2.975 7.46934 2.96875 7.50059L2.50781 10.1287C2.49261 10.2124 2.49804 10.2986 2.52364 10.3797C2.54923 10.4608 2.59421 10.5345 2.65469 10.5943C2.75781 10.6943 2.8875 10.749 3.02656 10.749ZM4.07969 8.02402L9.74687 2.3584L10.8922 3.50371L5.225 9.16934L3.83594 9.41465L4.07969 8.02402ZM12.75 12.0615H1.25C0.973437 12.0615 0.75 12.285 0.75 12.5615V13.124C0.75 13.1928 0.80625 13.249 0.875 13.249H13.125C13.1938 13.249 13.25 13.1928 13.25 13.124V12.5615C13.25 12.285 13.0266 12.0615 12.75 12.0615Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_34505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.f56138e34fad3e9838290063236cba02.svg";
export { ForwardRef as ReactComponent };